import { Component } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import UILink from 'UIComponents/link/UILink';
import Small from 'UIComponents/elements/Small';
import { getActionType, getErrorMessage, getDisplayEventId } from '../operators/errorActionGetters';
import { openHelpWidget } from '../util/openHelpWidget';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
class ErrorActionAlertBody extends Component {
  render() {
    const {
      action,
      eventId
    } = this.props;
    const actionType = getActionType(action);
    const displayEventId = getDisplayEventId(action);
    const message = getErrorMessage(action);
    return /*#__PURE__*/_jsxs("div", {
      children: [message || /*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: "conversations-error-reporting.errorAlert.message_jsx",
        options: {
          onClick: openHelpWidget
        },
        elements: {
          Link: UILink
        }
      }), displayEventId && eventId && /*#__PURE__*/_jsxs(Small, {
        use: "help",
        children: [' ', /*#__PURE__*/_jsx(FormattedMessage, {
          message: "conversations-error-reporting.errorAlert.eventId",
          options: {
            eventId
          }
        })]
      }), actionType && /*#__PURE__*/_jsxs(Small, {
        use: "help",
        children: [' ', /*#__PURE__*/_jsx(FormattedMessage, {
          message: "conversations-error-reporting.errorAlert.errorCode",
          options: {
            errorCode: actionType
          }
        })]
      })]
    });
  }
}
ErrorActionAlertBody.displayName = 'ErrorActionAlertBody';
export default ErrorActionAlertBody;